import * as React from 'react';
import { Card } from 'antd';

export interface ICategoryTitleProps {
  title: string;
  primaryColor: string;
  secondaryColor: string;
  isMobile: boolean;
}

export interface ICategoryTitleState {
  isMobile: boolean;
  softMenu: boolean;
}

class CategoryTitle extends React.Component<ICategoryTitleProps, ICategoryTitleState> {
  state = {
    softMenu: false,
    isMobile: false,
  };


  async componentDidMount() {

    if (window.innerWidth >= 550) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = () => {
    const position = window.pageYOffset;
    if (position >= 50) {
      this.setState({ softMenu: true });
    }
    else {
      this.setState({ softMenu: false });
    }
  };

  handleResize = () => {

    if (window.innerWidth >= 550) {
      this.setState({
        isMobile: false
      });
    }
    else {
      this.setState({
        isMobile: true
      });
    }

  }

  render() {


    return (<div style={{ background: 'transparent', fontSize: '0.9em'}}> 
      {this.state.isMobile === false ?
      (


        <div>{this.state.softMenu === true ? 
          (<div style={{ opacity: 0.7,
          float: 'left', position: 'fixed', top: -6, textAlign:  'center',
          right: 0, left: 110, zIndex: 99
        }}><Card bordered={true} className="font-face-gm" style={{
          fontSize: '1.8em',
          width: this.props.title.length < 6 ? '130px' : this.props.title.length < 10 ? '145px' : '170px', height: '36px', borderColor: this.props.secondaryColor,
          borderWidth: '1px',
          background: 'transparent',
          textAlign: 'center',
        }} >

            <div style={{ marginLeft: '-12%', marginTop: '-23px', opacity: '1',  
            color: this.props.secondaryColor, textAlign: 'center', }}>{this.props.title}</div>
          </Card></div>

        ) : ( 

          <div style={{
            float: 'left', position: 'fixed', top: -6, textAlign:  'center',
            right: 0, left: 110, zIndex: 99
          }}><Card bordered={true} className="font-face-gm" style={{
            fontSize: '1.8em',
            width: this.props.title.length < 6 ? '130px' : this.props.title.length < 10 ? '145px' : '170px', height: '36px', borderColor: this.props.primaryColor,
            borderWidth: '1px',
            background: 'transparent', 
            textAlign: 'center',
          }} >

              <div style={{ marginLeft: '-12%', marginTop: '-23px', opacity: '1', color: this.props.primaryColor, textAlign: 'center' }}>{this.props.title}</div>
            </Card></div>)}</div>

      ) : (

        <div>{this.state.softMenu === true ? 
          (<div style={{
          float: 'left', position: 'fixed', top: -6, textAlign:  'center', opacity: 0.7,
          right: 0, left: 0, zIndex: 99
        }}><Card bordered={true} className="font-face-gm" style={{
          fontSize: '1.5em',
          width: this.props.title.length < 6 ? '120px' : this.props.title.length < 10 ? '135px' : '160px', height: '28px', borderColor: this.props.secondaryColor,
          borderWidth: '1px', margin: 'auto',
          backgroundColor: 'white',
          textAlign: 'center',
        }} >

            <div style={{ marginLeft: '-10%', marginTop: '-23px', 
            opacity: '1', color: this.props.secondaryColor, textAlign: 'center' }}>{this.props.title}</div>
          </Card>

        </div>

        ) : (

          <div style={{
            float: 'left', position: 'fixed', top: -6, textAlign:  'center',
            right: 0, left: 0, zIndex: 99
          }}><Card bordered={true} className="font-face-gm" style={{
            fontSize: '1.5em',
            width: this.props.title.length < 6 ? '120px' : this.props.title.length < 10 ? '135px' : '160px', height: '28px', borderColor: this.props.primaryColor,
            borderWidth: '1px', margin: 'auto',
            backgroundColor: 'transparent',
            textAlign: 'center',
          }} >

              <div style={{ marginLeft: '-10%', marginTop: '-23px', opacity: '1', color: this.props.primaryColor, textAlign: 'center' }}>{this.props.title}</div>
            </Card>

          </div>)
        } </div>

      )}
    </div>);
  }

}

export default CategoryTitle;